import {apiSend, updateBrowserHistory} from "@util/api";

const {searchApi} = API;
const {langCode, languageName} = GLOBAL;

export default {
    searchApi(query, updateHistory = true) {
        query.lang = langCode


        this.loading = true;
        this.resultsValues.total = 0;
        this.coords.length && (query = [...this.coords]);

        apiSend(searchApi, {...this.query, language: languageName})
            .then(({data, status}) => status === 200 &&
                (this.resultsValues = {
                    ...data,
                    page: this.query?.page || 1,
                })
            )
            .finally(() => this.loading = false)

        const queryParams = query;
        queryParams.pages = this.query?.page
        delete queryParams.page;
        delete queryParams.coords;
        delete queryParams.isHcps;
        delete queryParams.language;

        updateHistory && updateBrowserHistory(queryParams)
    }
}
